import request from "./request";
/**
 * 更改用户状态
 * @param id 用户id
 * @param status 账户状态
 */
export default async function updateAccountStatus(data) {
  return await request.post("/spin/sysUser/updateAccountStatus", data);
}
